import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NotificationTurnOnBtnComponent } from '../notification-turn-on-btn/notification-turn-on-btn.component';
import { PassRequestsSidebarComponent } from '../pass-requests-sidebar/pass-requests-sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { PassesRoutingModule } from './passes-routing.module';
import { PassesStudentComponent } from './passes-student/passes-student.component';
import { TeacherHomeActivityComponent } from './passes-teacher/activities/teacher-home-activity.component';
import { DateComponent } from './passes-teacher/date/date.component';
import { DayTypeComponent } from './passes-teacher/day-type/day-type.component';
import { GreetingComponent } from './passes-teacher/greeting/greeting.component';
import { NoFlyTimeComponent } from './passes-teacher/no-fly-time/no-fly-time.component';
import { PassesTeacherV2Component } from './passes-teacher/passes-teacher-v2.component';
import { PeriodCountdownComponent } from './passes-teacher/period-countdown/period-countdown.component';
import { PassesComponent } from './passes.component';
import { StartPassNotificationComponent } from './start-pass-notification/start-pass-notification.component';
import { FuturePassesActivitiesComponent } from './passes-student/future-passes-activities/future-passes-activities.component';
import { ActivityTileLargeComponent } from './ui-components/activity-tile-large/activity-tile-large.component';

@NgModule({
	declarations: [
		PassesComponent,
		NotificationTurnOnBtnComponent,
		StartPassNotificationComponent,
		PassesStudentComponent,
		PassesTeacherV2Component,
		PassRequestsSidebarComponent,
		GreetingComponent,
		PeriodCountdownComponent,
		NoFlyTimeComponent,
		DayTypeComponent,
		DateComponent,
		TeacherHomeActivityComponent,
		FuturePassesActivitiesComponent,
		ActivityTileLargeComponent,
	],
	imports: [CommonModule, PassesRoutingModule, SharedModule],
})
export class PassesModule {}
